var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 0L26 26L0 26L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boton-agregar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 0L26 26L0 26L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.55859375 0.55859375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4414 0C5.58086 0 0 5.58086 0 12.4414C0 19.302 5.58086 24.8828 12.4414 24.8828C19.302 24.8828 24.8828 19.302 24.8828 12.4414C24.8828 5.58086 19.302 0 12.4414 0L12.4414 0ZM12.4414 22.811C6.72342 22.811 2.07186 18.1594 2.07186 12.4415C2.07186 6.72351 6.72342 2.07195 12.4414 2.07195C18.1594 2.07195 22.8109 6.72351 22.8109 12.4415C22.8109 18.1594 18.1594 22.811 12.4414 22.811L12.4414 22.811Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6008 11.4055L13.4773 11.4055L13.4773 7.28203C13.4773 6.7082 13.0152 6.24609 12.4414 6.24609C11.8676 6.24609 11.4055 6.7082 11.4055 7.28203L11.4055 11.4055L7.28203 11.4055C6.7082 11.4055 6.24609 11.8676 6.24609 12.4414C6.24609 13.0152 6.7082 13.4773 7.28203 13.4773L11.4055 13.4773L11.4055 17.6008C11.4055 18.1746 11.8676 18.6367 12.4414 18.6367C13.0152 18.6367 13.4773 18.1746 13.4773 17.6008L13.4773 13.4773L17.6008 13.4773C18.1746 13.4773 18.6367 13.0152 18.6367 12.4414C18.6367 11.8676 18.1746 11.4055 17.6008 11.4055L17.6008 11.4055Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.2449fa890bb34e4806e1a1bf9fe56ad2.svg";
export { ForwardRef as ReactComponent };